import { render, staticRenderFns } from "./traffic-light-widget.vue?vue&type=template&id=43c3a133"
import script from "./traffic-light-widget.vue?vue&type=script&lang=js"
export * from "./traffic-light-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports